import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { DocTypeCard } from '../components/DocTypeCard';
import { DoctypeType } from '../types';

type Props = {
  docTypes: DoctypeType[];
};
export const DocTypesList: FC<Props> = ({ docTypes }) => {
  return (
    <section>
      <div className='flex-grow-1 card-p pb-0'>
        <div className='d-flex flex-stack flex-wrap mb-3'>
          <div className='me-2'>
            <h4 className='text-dark text-hover-primary fw-bolder fs-5'>
              <FormattedMessage id='Docs Types' />
            </h4>
            <div className='text-muted fs-7 fw-bold'>
              <FormattedMessage id='Three sections contains all docs' />
            </div>
          </div>
          <div className='fw-bolder fs-3 text-primary'>
            <a
              href='/documents'
              className='btn btn-sm btn-flex btn-light btn-active-primary fw-bolder'
            >
              <span className='mx-2'>
                <FormattedMessage id='Show all' />
              </span>
              <i className='fas fa-arrow-right fs-9'></i>
            </a>
          </div>
        </div>
        {docTypes.map((docType) => (
          <DocTypeCard
            key={docType.titleId}
            docType={docType}
          />
        ))}
      </div>
    </section>
  );
};
